import { psAxios } from '@patsnap/common-ps-http';
import _ from 'lodash';

const BASE_PATH = 'eureka';
const FREE_PATH = 'share';

function insertFreePath(url: string): string {
    // 处理完整 URL（http/https 开头）
    if (url.startsWith('http')) {
        const urlObj = new URL(url)
        const path = urlObj.pathname

        // 如果路径以 /eureka 开头
        if (path.startsWith(`/${BASE_PATH}/`)) {
            urlObj.pathname = `/${BASE_PATH}/${FREE_PATH}${path.slice(BASE_PATH.length + 1)}`
        } else {
            // 不是以 /eureka 开头
            urlObj.pathname = `/${FREE_PATH}${path}`
        }

        return urlObj.toString()
    }

    // 处理相对路径
    const path = url.startsWith('/') ? url : '/' + url

    // 如果以 /eureka 开头
    if (path.startsWith(`/${BASE_PATH}/`)) {
        return `/${BASE_PATH}/${FREE_PATH}${path.slice(BASE_PATH.length + 1)}`
    }

    // 不是以 /eureka 开头
    return `/${FREE_PATH}${path}`
}

function escapeRegExp(string: string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const whiteListForKong = [
    // "/workspace/web/free-share/init", -- 不要忘记加在KONG里面，但是不能加在前端
    '/seek/init',
    '/seek/get_modules',
    '/eureka/sse/seek/summary',
    '/seek/outline',
    '/seek/semantics',
    '/seek/get-pum-chart',

    '/eureka/tech-mind/[^/]+',
    '/eureka/tech-mind/right_list',
    '/eureka/material-mind/[^/]+',
    '/eureka/material-mind/right_list'
];

const whiteListForJs = _.map(whiteListForKong, (item) => {
    const replaceKongRule = escapeRegExp(item.replace(/\[\^\/\]\+/g, '@'));
    const buildJsExp = replaceKongRule.replace(/@/g, '[a-zA-Z0-9_-]+') + '$';
    return new RegExp(buildJsExp);
});

function testWhiteList(url) {
    return _.some(whiteListForJs, (item) => item.test(url.split('?')[0]));
}

export const airShareInterceptor = (config) => {
    if (testWhiteList(config.url)) {
        config.url = insertFreePath(config.url);
    }
    return config;
};

export function injectAirShareInterceptor() {
    if (!psAxios.psInterceptors.airShareInterceptor) {
        psAxios.psInterceptors.airShareInterceptor = psAxios.interceptors.request.use(airShareInterceptor, () => {});
    }
}

export function ejectAirShareInterceptor() {
    psAxios.interceptors.request.eject(
        psAxios.psInterceptors.airShareInterceptor
    );
}

/**
 * 获取本地JWT token
 * @param {*} key
 * @returns
 */
export function getLocalToken(key = 'patsnap-authorizations') {
    let token = '';
    try {
        let authorizations = localStorage.getItem(key);
        if (authorizations) {
            authorizations = JSON.parse(authorizations);
        }
        if (authorizations && authorizations.token) {
            token = authorizations.token;
        }
        if (token) {
            token = `Bearer ${token}`;
        }
    } catch (error) {
        console.warn('getLocaleJWTToken', error);
    }
    return token;
}
